/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import { RegularButton } from 'pg-ui-library';
import { BulletinsManagerTable, MessagesManagerTable } from 'src/components';
import {
  ArrowBack,
  BackButton,
  Container,
  Content,
  Header,
  ManagerContainer,
  ManagerHeader,
  NavTextLink,
} from './styles';

const MessageAndBulletinsManager: React.FC = () => {
  const [addMessage, setAddMessage] = useState<boolean>(false);
  const [addBulletins, setAddBulletins] = useState<boolean>(false);

  const { t } = useTranslation();
  return (
    <Container>
      <Header>
        <BackButton>
          <NavTextLink to="/employee-management">
            <ArrowBack src={Arrow} />
            <span>{t('messageAndBulletinsManager.headerLink')}</span>
          </NavTextLink>
        </BackButton>
      </Header>
      <Content>
        <ManagerContainer>
          <ManagerHeader>
            <span>{t('messageAndBulletinsManager.messageTitle')}</span>
            <RegularButton>{t('messageAndBulletinsManager.messageButton')}</RegularButton>
          </ManagerHeader>
          <MessagesManagerTable />
        </ManagerContainer>
        <ManagerContainer>
          <ManagerHeader>
            <span>{t('messageAndBulletinsManager.bulletinsTitle')}</span>
            <RegularButton>{t('messageAndBulletinsManager.bulletinsButton')}</RegularButton>
          </ManagerHeader>
          <BulletinsManagerTable />
        </ManagerContainer>
      </Content>
    </Container>
  );
};

export default MessageAndBulletinsManager;
